module.exports = __webpack_public_path__ + "static/media/kw.0d0ac54c.svg";